//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { UIATrackingIds } from '@uia/constants/uiaConstants';
import {
  ContentSourceBadgeAvatar,
  ContentSourceBadgeAvatarProps,
} from '@uia/details/badge/ContentSourceBadgeAvatar';
import { isDefined } from '@utils/filterPredicates';
import { withTracking } from '@utils/withTracking';

export interface ContentSourceBadgeProps extends ContentSourceBadgeAvatarProps {
  hrefLink?: string;
}

export const ContentSourceBadge = ({
  hrefLink,
  ...avatarProps
}: ContentSourceBadgeProps) => (
  <Badge>
    {isDefined(hrefLink) ? (
      <BadgeLink
        href={hrefLink}
        trackingId={UIATrackingIds.DETAILS_OPEN_BADGE_LINK}
        {...(avatarProps.isRouteToExternal
          ? { rel: 'noreferrer', target: '_blank' }
          : {})}
      >
        <ContentSourceBadgeAvatar {...avatarProps} />
      </BadgeLink>
    ) : (
      <ContentSourceBadgeAvatar {...avatarProps} />
    )}
  </Badge>
);

const Badge = styled.div(
  ({ theme }) => `
    display: flex;
    padding: ${theme.spacings[2]} ${theme.spacings[0]};
  `,
);

const BadgeLink = withTracking(
  styled.a(
    () => `
      cursor: pointer;
  
      &&:hover {
        text-decoration: none;
      }
    `,
  ),
);
